import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

interface AdditionalOptions {
  option: 'lifting' | 'noOption' | 'unloading';
  leaveByTheDoor: boolean;
}

const initialValue: AdditionalOptions = {
  option: 'noOption',
  leaveByTheDoor: false,
};

@Injectable({
  providedIn: 'root',
})
export class AdditionalOptionsFormService {
  form: FormGroup;

  constructor(private fb: FormBuilder) {}

  reset(): void {
    this.form?.patchValue(initialValue);
  }

  createForm(): FormGroup {
    if (!this.form) {
      this.form = this.fb.group(initialValue);
    }

    return this.form;
  }

  getFormValue(): AdditionalOptions {
    return this.form.value;
  }
}
